import React, {useRef, useState} from 'react';
//External
import {
    Button,
    Input, Progress,
} from "reactstrap";
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlay} from "@fortawesome/free-solid-svg-icons/faPlay";
import {faMicrophone} from "@fortawesome/free-solid-svg-icons/faMicrophone";
import ReactAudioPlayer from "react-audio-player";
import {faPause} from "@fortawesome/free-solid-svg-icons/faPause";
import {secondsToHms} from "../../Common/Appcommon";

const AudioPlayer = props => {
    const audioRef = useRef();
    const [audioIcon, setAudioIcon] = useState(faPlay);
    const [canPlay, setAudioAction] = useState(false);
    const [audioDuration, setAudioDuration] = useState("00:00");
    const [rawAudioDuration, setRawAudioDuration] = useState(0);
    const [progressData, setProgressData] = useState(0);
    let audioUrl = props.audioUrl;
    //let audioPlayer = new Audio(audioUrl);
    const onPlayButtonClick = async () => {
        setAudioAction(!canPlay);
        if(canPlay){
            audioRef.current.pause();
            setAudioIcon(faPlay);
        } else {
            audioRef.current.play();
            setAudioIcon(faPause);
        }
    }

    const onLoadedMetadata = () => {
        if (audioRef.current) {
            setAudioDuration(secondsToHms(audioRef.current.duration));
            setRawAudioDuration(audioRef.current.duration);
        }
    };

    const onTimeUpdate = (event) =>{
        let currentTime = event.target.currentTime;
        let liveDuration = (currentTime / rawAudioDuration) * 100;
        setAudioDuration(secondsToHms(currentTime));
        liveDuration = parseInt(liveDuration);
        setProgressData(liveDuration);
    }

    return (
        <>
            <div className={'crap'}>
                <div className="buoZm" aria-hidden="true">{audioDuration}</div>
                <div className={'cr-audio-player'}>
                    <audio
                        ref={audioRef}
                        src={audioUrl}
                        onLoadedMetadata={onLoadedMetadata}
                        onTimeUpdate={onTimeUpdate}
                    />
                    <div className="au-play-btn">
                        <FontAwesomeIcon onClick={onPlayButtonClick} className={'play-icon'} icon={audioIcon} />
                    </div>
                    <Progress className="progress-bar-xs audio-play-canvas" value={progressData} />
                    <div className={'au-mic'}>
                        <FontAwesomeIcon className={'mic-icon'} icon={faMicrophone} />
                    </div>
                </div>
            </div>
        </>
    );
}
export default AudioPlayer;
